import { z } from 'zod';
import { countryIsoSchema, currencyIsoSchema, idSchema } from './utility';

export const productSchema = z.object({
  id: idSchema,
  internal_id: z.string(),
  type: z.enum(['notice', 'demand_letter', 'hard_1', 'hard_2']),
  name: z.string(),
  client_country_iso: countryIsoSchema.nullable(),
  debtor_country_iso: countryIsoSchema.nullable(),
  currency_iso: currencyIsoSchema,
});